import { ActionType } from "../../model/actionTypes";
import { errorHandler } from "./auth";

export const getOdPaymentTypes = (practiceIds: number[], params?: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const query = { practiceIds: JSON.stringify(practiceIds), ...params };
        const resp = await api.get("payment-type/odPaymentTypes", null, query);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch(errorHandler(err));
        return [];
    }
};

export const createOdPaymentType = (data: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp = await api.post("payment-type/odPaymentType", data, null);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch({ type: ActionType.ALERT, payload: err });
        return {};
    }
};
